import { render, staticRenderFns } from "./PagesList.vue?vue&type=template&id=4b27b5d4&scoped=true&"
import script from "./PagesList.vue?vue&type=script&lang=js&"
export * from "./PagesList.vue?vue&type=script&lang=js&"
import style0 from "./PagesList.vue?vue&type=style&index=0&id=4b27b5d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b27b5d4",
  null
  
)

export default component.exports